import get from 'lodash/get';
import * as Api from '../api';
import * as Mappers from '../mappers';
import * as Types from '../types';

interface IProps {
  id: string;
}

const Single = ({ id }: IProps): [string[], () => Promise<Types.IQuery.Single>] => [
  ['result', 'single', id],
  async () => {
    const { data } = await Api.Single({ id });

    const item = Mappers.ResultDetails(get(data, 'data'));

    return {
      item,
    };
  },
];

export default Single;
